const ticketTypeMapEnum = {

  LUNCH: "Almoço",

  STUDENT_LUNCH_TICKET: "Almoço - Estudante",
  STUDENT_DINNER_TICKET: "Jantar - Estudante",

  EXTERNAL_DINNER_TICKET: "Jantar - Externo",
  EXTERNAL_LUNCH_TICKET: "Almoço - Externo",
  
  SCHOLARSHIP_LUNCH_TICKET: "Almoço - Estudante Bolsista",
  SCHOLARSHIP_DINNER_TICKET: "Jantar - Estudante Bolsista",
};


export default Object.freeze(ticketTypeMapEnum);

